import React, { Fragment, useContext, useEffect, useState } from "react";
import classNames from "classnames/bind";
import PlayBackIcon from "../../../../../components/Icons/PlayBackIcon";
import DownLoadIcon from "../../../../../components/Icons/DownLoadIcon";
import { Pagination, Toast } from "../../../../../components";
import Table from "./Table";
import {
  downloadVideo,
  formatDateToTime,
  sorterArray,
} from "../../../../../utils";
import styles from "./Table.module.css";
import NameCol from "../../../../../components/NameCol";
import emptyImage from "../../../../../assets/images/Emty.png";
import axios from "axios";
import ProgressBar from "../../../../../components/ProgressBar";
import { useStoreContext } from "../../../../../hooks/useStoreContext";
import { TracingEventContext } from "../../../../../contexts";

const cx = classNames.bind(styles);
const TableCamera = ({ data, pages, currentPage, getPage, setPages, setCurrentPage }) => {
  const {
    cameraCode,
    setCameraCode,
    url,
    setUrl,
    isShow,
    setIsShow,
    name,
    setName,

  } = useContext(TracingEventContext);
  const [toggleSort, setToggleSort] = useState(false);
  const [dataTable, setDataTable] = useState();
  const [method, setMethod] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [downloadInfo, setDownloadInfo] = useState({
    progress: 0,
    completed: false,
    total: 0,
    loaded: 0,
    index: null,
    cancel: false,
  });
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext();
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  // console.log(dataTable);
  const dataSource = dataTable?.map((item, index) => {
    return {
      stt: index + 1,
      description: item.name_cam,
      code: item.camera_code,
      has_event: item?.has_event,
    };
  });
  useEffect(() => {
    const newData = data.length > 0 ? [...data] : null;
    const dataFilter = data.filter(
      (item, index) => ((currentPage - 1) * 10 <= index && index < currentPage * 10)
    );
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case "up":
          const dataSortUp = sorterArray(dataFilter, method);
          setDataTable(dataSortUp);
          break;
        case "down":
          const dataSortDown = sorterArray(dataFilter, method);
          setDataTable(dataSortDown.reverse());
          break;
        default:
          setDataTable(dataFilter);
          break;
      }
    } else {
      setDataTable(dataFilter);
    }
  }, [data, toggleSort, method, currentPage]);

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type);
      setMethod(method);
    } else {
      setToggleSort(false);
      setMethod("");
    }
  };

  const columns = [
    {
      label: "STT",
      key: "stt",
    },
    {
      label: (
        <NameCol
          active={method}
          title={"Tên camera"}
          handleSort={handleSort}
          method={"TIME_START"}
        />
      ),
      key: "description",
    },
  ];

  const handleNext = () => {
    getPage(currentPage + 1);
  };
  const handlePrevious = (data) => {
    getPage(currentPage - 1);
  };

  const handleChosePage = (data) => {
    getPage(data);
  };

  const handleClose = () => {
    setIsLoading(false);
  };
  const handleClick = (item) => {
    setCameraCode(item.code);
    setName(item.description);
    setCurrentPage(1)
  };
  return (
    <div
      style={{
        flex: 2,
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
      }}
    >
      <Table onClick={handleClick} data={dataSource} colum={columns} />
      {data?.length === 0 && name && name !== "Phát hiện chuyển động" && (
        <div className={cx("empty")}>
          <img src={emptyImage} alt="no-record" className={cx("empty-img")} />
          <p>Không có camera được chọn</p>
        </div>
      )}
      {data?.length === 0 && name && name === "Phát hiện chuyển động" && (
        <div className={cx("empty")}>
          <p>Vui lòng lựa chọn camera để xem video {name?.toLowerCase()}!</p>
        </div>
      )}
      {data?.length > 0 && (
        <div className={cx("pagination")}>
          <Pagination
            pages={pages}
            currentPage={currentPage}
            onNext={handleNext}
            onPrevious={handlePrevious}
            onClick={(e) => handleChosePage(e)}
          />
        </div>
      )}
      {/* {isLoading && (
        <ProgressBar data={downloadInfo} onClose={handleClose} handleCancel={source.cancel()} />
      )} */}
    </div>
  );
};

export default TableCamera;
